<script setup lang="ts">
import { getApproveList } from "@/api/sign";

const props = defineProps({
  type: { type: Number, default: 0 }, // type 0 待处理  1 已处理
});
const emits = defineEmits(["onClickItem"]);
const isEmpty = ref(true);
const refreshing = ref(false);
const dataList: any = ref([]);
const onRefresh = () => {
  getApproveList({ signStatus: props.type })
    .then((res: any) => {
      refreshing.value = false;
      if (res && res.length > 0) {
        isEmpty.value = false;
        dataList.value = res;
      } else {
        isEmpty.value = true;
        dataList.value = [];
      }
    })
    .catch(() => {
      refreshing.value = false;
      isEmpty.value = true;
      dataList.value = [];
      showFailToast("网络异常");
    });
};
// item 标题
const itemTitle = (item) => {
  if (item) {
    const typeName = item.type === 1 ? "内勤" : "外勤";
    return `${item.empName}的${typeName}审批`;
  }
  return "";
};
// 0:待审核，1:审核通过，2:审核拒绝
const states = (status) => {
  if (status === 0) {
    return "待审核";
  }
  if (status === 1) {
    return "审核通过";
  }
  if (status === 2) {
    return "审核拒绝";
  }
};
const onClickItem = (item: any) => {
  emits("onClickItem", item);
};
onActivated(() => {
  refreshing.value = true;
  onRefresh();
});
</script>

<template>
  <div class="item-main">
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      pull-distance="300"
    >
      <van-empty v-if="isEmpty" description="暂无数据" />
      <van-list style="height: 100%">
        <div
          class="item-content"
          v-for="item in dataList"
          :key="item.signInId"
          @click="onClickItem(item)"
        >
          <div class="top-title">
            <span> {{ itemTitle(item) }}</span>
            <span>{{ states(item.signStatus) }}</span>
          </div>
          <span>签到时间: {{ item?.signTime }}</span>
          <span>签到地址: {{ item?.signAddress }}</span>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<style scoped>
.item-main {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #fff;
}
.item-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  border-bottom: 1px solid #ececec;
  padding: 10px;
}
.top-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0px;
}
</style>
